import { render, staticRenderFns } from "./SettlementGLSetup.vue?vue&type=template&id=63938d74&"
import script from "./SettlementGLSetup.vue?vue&type=script&lang=js&"
export * from "./SettlementGLSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports